module.exports = __webpack_public_path__ + "img/selected1-min.9e82619a.png";